import React from 'react';
import { Button, Input } from 'reactstrap';
import { FormFieldHeader } from '../../../../../../components/FormFieldHeader';
import { AlertMessage } from '../../../../../../components/AlertMessage';
import { LoadingSpinnerIconSpan } from '../../../../../../components/LoadingSpinnerIconSpan';

interface APIKeyFormProps {
  apiKeyName: string;
  setApiKeyName: (name: string) => void;
  isSaving: boolean;
  isFormValid: boolean;
  onClose: () => void;
  onSubmit: (e?: React.FormEvent) => void;
}

export function APIKeyForm({
  apiKeyName,
  setApiKeyName,
  isSaving,
  isFormValid,
  onClose,
  onSubmit,
}: APIKeyFormProps) {
  return (
    <>
      <div className='mb-3 fw-normal'>
        Generate a new API key to securely authenticate and integrate with our
        API interface.
      </div>

      <form onSubmit={onSubmit}>
        <FormFieldHeader
          fieldName='Key Name'
          isRequired={true}
          hideRequireIndicator={true}
          classNames='mb-2 fs-5'
        />
        <Input
          type='text'
          value={apiKeyName}
          onChange={(e) => setApiKeyName(e.target.value)}
          placeholder='e.g., Production API'
          disabled={isSaving}
          aria-label='Enter Key Name'
          className='form-control mb-3 mt-0'
        />

        <AlertMessage
          hasOverlay={false}
          icon={{ name: 'bi-info-circle' }}
          className='mb-4 mt-0 fs-5 bg-light-danger'
          text={
            <span>
              Make sure to copy and store the API key in a safe place since you
              won&apos;t be able to view it again.
            </span>
          }
        />

        <div className='d-flex mt-4 justify-content-end'>
          <Button
            type='button'
            color='danger'
            className='me-2'
            onClick={onClose}
            disabled={isSaving}
          >
            Cancel
          </Button>
          <Button
            type='submit'
            disabled={!isFormValid || isSaving}
            color='primary'
          >
            {isSaving ? (
              <>
                <LoadingSpinnerIconSpan
                  iconClassName='text-white'
                  textClassName={'ps-2 fs-5 fw-normal'}
                  text={'Generating'}
                />
              </>
            ) : (
              'Generate'
            )}
          </Button>
        </div>
      </form>
    </>
  );
}
